export enum SubmissionTypes {
  Error = 'error',
  Success = 'success',
}

// PLEASE MAKE YOUR TYPES, DON'T JUST DISABLE IT
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SubmissionError = any;

export interface SubmissionResult<T> {
  type: SubmissionTypes;
  payload: T | SubmissionError;
}
